module.exports = __webpack_public_path__ + "img/cross.230af629.svg";